/*
  mobile_inline_slider
*/
/**
 * Mobile Inline Slider PLUGIN
 */
 /************************************************
          PLUGIN ACTIVATION
 *************************************************/
$(document).ready(function(){
  $("[class^=mob_slider-] .controls .control").click(function(e){
    if ($(this).hasClass("right")) {
      $(this).parents().find(".slider").stop().animate({scrollLeft:"+=125"}, 500);
    }
    else if ($(this).hasClass("left")) {
      $(this).parents().find(".slider").stop().animate({scrollLeft:"-=125"}, 500);
    }
  });
});
